module.exports = __webpack_public_path__ + "img/cycle.57b89008.png";